import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Cache from 'i18next-localstorage-cache';
import LanguageDetector from "i18next-browser-languagedetector";

i18n
	.use(LanguageDetector)
	.use(Cache)
	.use(initReactI18next)
	.init({
		resources: {},

		// lng: "en-US",  // default language
		fallbackLng: "en-US", // when specified language translations not present then fallbacklang translations loaded.
		debug: false,

		interpolation: {
			escapeValue: false,
			formatSeparator: ",",
		},

		react: {
			wait: true,
			defaultTransParent: 'div', // a valid react element - required before react 16
			transEmptyNodeValue: '', // what to return for empty Trans
    		transSupportBasicHtmlNodes: true, // allow <br/> and simple html elements in translations
    		transKeepBasicHtmlNodesFor: ['br', 'strong', 'i'], // don't convert to <1></1> if simple react elements
		},
	});

import("ui/I18nService").then((I18nService) => {
	I18nService.default.init(i18n)
})

export default i18n;